module.exports = __webpack_public_path__ + "02f7d58d04bfbaf96f4f0977fd94151b.svg";